<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New Employee Branding</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                label="Image"
                horizontal
                class="required"
                type="file"
                accept=".png, .jpg, .jpeg, .webp"
                :isValid="validate.attachment_employee_branding_photo_url.isValid"
                :invalidFeedback="validate.attachment_employee_branding_photo_url.message"
                @change="handleImage"
              >
              <template v-slot:label-after-input>
                File size should be below 150KB and Optimize picture size is 310px
                x 465px.
                <CRow class="form-group" v-if="url">
                  <CCol :col="8">
                    <img
                      class="image-employee"
                      id="myImg"
                      width="127px"
                      height="170px"
                      alt=""
                      :src="url" />
                  </CCol>
                </CRow>
              </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Name"
                class="mb-0 required is-invalid"
                type="text"
                required
                horizontal
                placeholder="Name"
                v-model="employeeBrandingData.employee_name"
                :isValid="validate.employee_name.isValid"
                :invalidFeedback="validate.employee_name.message"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Position"
                class="mb-0 required is-invalid"
                type="text"
                required
                horizontal
                placeholder="position"
                v-model="employeeBrandingData.employee_position"
                :isValid="validate.employee_position.isValid"
                :invalidFeedback="validate.employee_position.message"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CTextarea
                label="Testimonial"
                class="mb-0 required"
                type="text"
                required
                horizontal
                placeholder="Testimonial"
                v-model="employeeBrandingData.testimonial"
                :isValid="validate.testimonial.isValid"
                :invalidFeedback="validate.testimonial.message"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                label="Status"
                :options="optionsStatus"
                required
                class="required"
                horizontal
                placeholder="Pilih"
                v-model="employeeBrandingData.status"
                :isValid="validate.status.isValid"
                :invalidFeedback="validate.status.message"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                type="number"
                min="0"
                max="1000"
                label="Priority"
                required
                horizontal
                placeholder="Priority"
                v-model="employeeBrandingData.priority"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                color="success"
                class="float-right"
                @click="createEmployeeBranding"
                >Save</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import mixins from "../misc/mixins";
import CareerUseCase from "../app/usecase/career";

export default {
  name: "EmployeeBrandingAdd",
  mixins: [mixins],
  methods: {
    async createEmployeeBranding() {
      this.showErrorField = true
      if (this.errorForms && this.errorForms.error) return
      const formData = new FormData()

      formData.append('attachment_employee_branding_photo_url', this.employeeBrandingData.attachment_employee_branding_photo_url)
      formData.append('employee_name', this.employeeBrandingData.employee_name)
      formData.append('employee_position', this.employeeBrandingData.employee_position)
      formData.append('testimonial', this.employeeBrandingData.testimonial)
      formData.append('status', this.employeeBrandingData.status)
      formData.append('priority', this.employeeBrandingData.priority || '')

      const {data, err} = await CareerUseCase.create(formData)

      if (data) {
        this.$swal.fire({
          icon: "success",
          title: "Employee Branding Created",
          showConfirmButton: false,
          timer: 2000,
        })
        this.$router.push({ path: `/career/employee-branding` });
      }

      if (err) {
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: err
        })
      }

    },
  }
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Poppins&display=swap");
</style>
<style>
.form-group.required .col-form-label::after {
  content: "*";
  color: red;
}
.form-row.required .col-form-label::after {
  content: "*";
  color: red;
}

</style>
